import { Box, Button, Typography, ButtonProps } from "@mui/material";

type ButtonUnderwriterProps = {
  onClick: () => void;
  icon: string;
  label: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  color?: string;
  width?: number | string;
  height?: number | string;
  textTransform?: "none" | "capitalize" | "uppercase" | "lowercase";
  fontSize?: number | string;
};

export default function ButtonUnderwriter({
  onClick,
  icon,
  label,
  variant = "contained",
  size = "medium",
  color,
  width ="180px",
  height="40px",
  textTransform = "none",
  fontSize = "16px",
}: ButtonUnderwriterProps) {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      size={size}
      sx={{
        width,
        minWidth: width,
        height,
        textTransform,
        fontSize,
        justifyContent: "center",
        px: 2,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        borderRadius: 20,
        gap: 1,
        backgroundColor: color,
        color: "#fff",
        "&:hover": {
          backgroundColor: color,
          opacity: 0.9,
        },
      }}
    >
      <Box
        component="img"
        src={icon}
        alt={label}
        sx={{ width: 24, height: 24, flexShrink: 0 }}
      />
      <Typography
        color="#FFFFFF"
        fontSize={fontSize}
        fontWeight={600}
        lineHeight={1}
        noWrap
      >
        {label}
      </Typography>
    </Button>
  );
}
